import LiveLike from '@livelike/engagementsdk';

let livelikeClient = null;
export const initializeLiveLike = async ({ clientId, accessToken }) => {
    try {
        await LiveLike.init({
            clientId,
            accessToken,
        }).then((profile) => {
            if (profile) {
                livelikeClient = profile;
            }
        });
    } catch (error) {
        if (error) {
            livelikeClient = null;
        }
    }

    if (livelikeClient) {
        return LiveLike;
    }
};

export const isSDKInitialized = (sdkClient) => {
    if (!sdkClient) {
        return false;
    }
    return true;
};
